var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgress = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 4.25H1.25v7.5H13A1.75 1.75 0 0 0 14.75 10V6A1.75 1.75 0 0 0 13 4.25zM2.75 6.75v-1H13a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25H2.75v-1h7.5v-2.5h-7.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgress);
export default ForwardRef;